import React, { useState, useEffect } from "react";
import {
  Button,
  Container,
  Form,
  Alert,
  Table,
  ProgressBar,
} from "react-bootstrap";
import { ref, push, set, onValue, remove, update } from "firebase/database";
import { database } from "../firebaseConfig";
import axios from "axios";





const GITHUB_TOKEN = "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";

const SharePage = () => {
  const [title, setTitle] = useState("");
  const [questionPaperFile, setQuestionPaperFile] = useState(null);
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [error, setError] = useState("");
  const [sharedData, setSharedData] = useState([]);
  const [editData, setEditData] = useState(null);

  useEffect(() => {
    const sharedDataRef = ref(database, "shared_data/");
    const unsubscribe = onValue(sharedDataRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const formattedData = Object.keys(data).map((key) => ({
          id: key,
          ...data[key],
        }));
        setSharedData(formattedData);
      } else {
        setSharedData([]);
      }
    });

    return () => unsubscribe();
  }, []);

  const GITHUB_REPOS = [
    "S1",
    "S2",
    "S3",
    "S4",
    "S5",
    "S6",
    "S7",
    "S8",
    "S9",
    "S10",
  ];
  
  const uploadFileToGitHub = async (file) => {
    for (let repo of GITHUB_REPOS) {
      try {
        const timestamp = new Date()
          .toISOString()
          .split(".")[0]
          .replace(/[-T:]/g, "");
        const fileName = `${file.name.split(".")[0]}_${timestamp}.${file.name
          .split(".")
          .pop()}`; // Add timestamp to filename
        const fileContent = await file.arrayBuffer();
        const base64Content = btoa(
          new Uint8Array(fileContent).reduce(
            (data, byte) => data + String.fromCharCode(byte),
            ""
          )
        );
  
        const response = await axios.put(
          `https://api.github.com/repos/pragyeshias/${repo}/contents/${fileName}`,
          {
            message: `Upload ${fileName}`,
            content: base64Content,
          },
          {
            headers: {
              Authorization: `token ${GITHUB_TOKEN}`,
            },
            onUploadProgress: (progressEvent) => {
              const progress = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              setUploadProgress(progress);
            },
          }
        );
  
        setUploadProgress(0); // Reset progress bar
        return response.data.content.download_url; // Return the URL of the uploaded file
      } catch (error) {
        console.error(`Error uploading file to ${repo}:`, error);
        // If the upload fails, try the next repository
        continue;
      }
    }
    
    // If none of the repositories work, throw an error
    throw new Error("All repository uploads failed.");
  };
  
  

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      let questionPaperLink = "";

      if (questionPaperFile) {
        questionPaperLink = await uploadFileToGitHub(questionPaperFile);
      }

      const sharedDataRef = ref(database, "shared_data/");
      const newDataRef = push(sharedDataRef);

      await set(newDataRef, {
        title,
        questionPaperLink,
        description,
        timestamp: new Date().toISOString(),
      });

      setTitle("");
      setQuestionPaperFile(null);
      setDescription("");

      alert("Data shared successfully!");
    } catch (error) {
      console.error("Error sharing data:", error);
      setError("There was an error sharing the data. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      const dataRef = ref(database, `shared_data/${id}`);
      await remove(dataRef);
      alert("Data deleted successfully!");
    } catch (error) {
      console.error("Error deleting data:", error);
      alert("There was an error deleting the data.");
    }
  };

  const handleEdit = (item) => {
    setEditData(item);
    setTitle(item.title);
    setDescription(item.description);
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const dataRef = ref(database, `shared_data/${editData.id}`);

      await update(dataRef, {
        title,
        description,
        timestamp: new Date().toISOString(),
      });

      setEditData(null);
      setTitle("");
      setDescription("");

      alert("Data updated successfully!");
    } catch (error) {
      console.error("Error updating data:", error);
      setError("There was an error updating the data. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="share-page">
      <Container style={{ marginTop: "80px" }}>
        <h1 className="mt-4 text-center text-success">
          <i className="bi bi-share-fill me-2"></i> Share Questions
        </h1>
        <p className="text-center text-muted">
          Share important updates and resources with users. Make a difference!
        </p>

        {error && <Alert variant="danger">{error}</Alert>}

        <div className="form-container shadow-lg p-4 rounded bg-light mt-5">
          <Form onSubmit={editData ? handleUpdate : handleSubmit}>
            <Form.Group className="mb-3" controlId="formTitle">
              <Form.Label>
                <i className="bi bi-pencil-square me-2"></i> Title
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formQuestionPaperFile">
              <Form.Label>
                <i className="bi bi-file-earmark-arrow-up me-2"></i> Question
                Paper File
              </Form.Label>
              <Form.Control
                type="file"
                onChange={(e) => setQuestionPaperFile(e.target.files[0])}
                required
              />
            </Form.Group>

            {uploadProgress > 0 && (
              <ProgressBar
                animated
                now={uploadProgress}
                label={`${uploadProgress}%`}
                className="mb-3"
              />
            )}

            <Form.Group className="mb-3" controlId="formDescription">
              <Form.Label>
                <i className="bi bi-chat-text-fill me-2"></i> Description
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Enter description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                required
              />
            </Form.Group>

            <div className="d-flex justify-content-between align-items-center">
              <Button
                variant="success"
                type="submit"
                disabled={loading}
                className="d-flex align-items-center"
              >
                <i className="bi bi-send me-2"></i>
                {loading
                  ? editData
                    ? "Updating..."
                    : "Sharing..."
                  : editData
                  ? "Update"
                  : "Share Now"}
              </Button>
              {editData && (
                <Button
                  variant="secondary"
                  onClick={() => {
                    setEditData(null);
                    setTitle("");
                    setDescription("");
                  }}
                  className="d-flex align-items-center"
                >
                  <i className="bi bi-x-circle me-2"></i> Cancel
                </Button>
              )}
            </div>
          </Form>
        </div>

        <h2 className="mt-5 text-center">
          <i className="bi bi-card-list me-2"></i> Shared Data
        </h2>
        {sharedData.length > 0 ? (
          <div className="table-responsive mt-3">
            <Table bordered hover className="shadow-sm rounded">
              <thead className="bg-success text-white">
                <tr>
                  <th>Title</th>
                  <th>Question Paper Link</th>
                  <th>Description</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {sharedData.map((item) => (
                  <tr key={item.id}>
                    <td>{item.title}</td>
                    <td>
                      <a
                        href={item.questionPaperLink}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="bi bi-file-earmark-text me-1"></i>{" "}
                        Download
                      </a>
                    </td>
                    <td>{item.description}</td>
                    <td>
                      <Button
                        variant="warning"
                        size="sm"
                        className="me-2 d-flex align-items-center"
                        onClick={() => handleEdit(item)}
                      >
                        <i className="bi bi-pencil-square me-1"></i> Edit
                      </Button>
                      <Button
                        variant="danger"
                        size="sm"
                        className="d-flex align-items-center"
                        onClick={() => handleDelete(item.id)}
                      >
                        <i className="bi bi-trash me-1"></i> Delete
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        ) : (
          <p className="text-muted mt-3 text-center">
            <i className="bi bi-emoji-frown me-2"></i>No data shared yet.
          </p>
        )}
      </Container>

      {/* Custom Styles */}
      <style jsx>{`
        .form-container {
          max-width: 600px;
          margin: 0 auto;
        }
        @media (max-width: 768px) {
          .form-container {
            padding: 1rem;
          }
          .table-responsive {
            overflow-x: auto;
          }
        }
        .btn-success,
        .btn-warning,
        .btn-danger {
          transition: all 0.3s ease;
        }
        .btn-success:hover {
          background-color: #045d4b;
        }
        .btn-warning:hover {
          background-color: #d69300;
        }
        .btn-danger:hover {
          background-color: #a40000;
        }
        h1,
        h2 {
          text-shadow: 1px 1px 2px #00000050;
        }
      `}</style>
    </div>
  );
};

export default SharePage;
